import { gql } from 'apollo-angular';

export const GET_ENVIRONMENTS_BY_FUNCTIONAL_GROUP = gql`
	query analyzerGetEnvironmentsByFunctionalGroupUid($functionalGroupUid: String!) {
		analyzerGetEnvironmentsByFunctionalGroupUid(functionalGroupUid: $functionalGroupUid) {
			analyzerEnvironments
		}
	}
`;
